import { AccordionTypes, UI, VStack } from '@genial/components';
import { Pressable } from 'native-base';
import React, { useState } from 'react';

import { AssetNoticesNormalized } from '../..';

export interface MobileNoticesProps {
  notices: AssetNoticesNormalized[];
}

export const MobileNotices: React.FC<MobileNoticesProps> = ({ notices }) => {
  const [accordionState, setAccordionState] = useState<AccordionTypes.Status>('closed');

  const handlePress = () => {
    setAccordionState((prevState) => (prevState === 'closed' ? 'opened' : 'closed'));
  };

  const handleClose = () => {
    setAccordionState('closed');
  };

  return (
    <UI.Accordion
      testId="alerts-info"
      status={accordionState}
      onPress={handlePress}
      onClosed={handleClose}
      hasShadow={false}>
      <UI.Accordion.Visible w="full" flex={1} hideDefaultIcons>
        <Pressable onPress={handlePress}>
          <UI.Icon name="Info" size="xs" color="neutral.medium" />
        </Pressable>
      </UI.Accordion.Visible>
      <UI.Accordion.Expanded>
        <VStack space="stack.xxxs">
          {notices.map((notice, index) => (
            <UI.Notice key={`notice-${notice.id}-${index}`} {...notice} />
          ))}
        </VStack>
      </UI.Accordion.Expanded>
    </UI.Accordion>
  );
};
